import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Loader from './common/loader/Loader';
import useLoggedInAccess from '../hooks/useLoggedInAccess';
import { AccessProvider } from '../store/access/AccessContext';
import { isRouteAllowed } from '../utils/role-based-access/isRouteAllowed';
import { getAuthorizedRedirectPath } from '../utils/role-based-access/getAuthorizedRedirectPath';

export const LoggedInContainer = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const access = useLoggedInAccess();

  if (access.status === 'loading') {
    return <Loader />;
  }

  if (access.menuGuardEnabled && access.status === 'ready' && access.allowedPaths.length > 0) {
    const isAllowed = isRouteAllowed(location.pathname, access.allowedPaths);
    if (!isAllowed) {
      const redirectPath = getAuthorizedRedirectPath(access.allowedPaths, '/home');
      if (location.pathname !== redirectPath) {
        return <Navigate to={redirectPath} replace />;
      }
    }
  }

  return <AccessProvider access={access}>{children}</AccessProvider>;
};

export default LoggedInContainer;
